module.exports = __webpack_public_path__ + "media/DINPro-Condensed-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DINPro-Condensed/DINPro-Condensed-Bold.eot
// module id = 579
// module chunks = 57